import * as d3 from "d3";
import { useEffect, useState } from "react";

type LineChart2props = {
  [x: string]: any;
  data: Array<{
    label: Date;
    val: number;
    // z: number;
  }>;
};

function LineChart2(props: LineChart2props) {
  // const [data, setData] = useState([]);

  function generateUUID() {
    return "LineG_xxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  const [container, setContainer] = useState(generateUUID());
  //console.log(generateUUID())

  useEffect(() => {
    if (props.data.length > 0) {
      drawChart();
    } else {
      d3.select("#" + container)
        .selectChildren()
        .remove();
      //console.log('is this being called')
    }
  }, [props]);
  //console.log(props.data)
  // console.log("window.innerwidth:", window.innerWidth);
  // console.log("window.innerwidth 60:", window.innerWidth * 0.6);
  // console.log("internal width:", props.width);

  const drawChart = () => {
    //console.log("startofChart2");
    // const width = 928;
    const width = props.width;
    const height = 500;
    const marginTop = 20;
    const marginRight = 30;
    const marginBottom = 30;
    const marginLeft = 40;

    // Declare the x (horizontal position) scale.
    let xVals = d3.map(props.data, (d) => d.label);

    const xScale = d3.scaleUtc(
      d3.extent(props.data, (d) => d.label),
      [marginLeft, width - marginRight],
    );

    // Declare the y (vertical position) scale.
    let yVals = d3.map(props.data, (d) => d.val);
    var numY = yVals.map(Number);

    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(numY)])
      .range([height, 0]);

    const points = props.data.map((d) => [
      xScale(d.label),
      yScale(d.val),
      d.val,
    ]);
    const groups = d3.rollup(
      points,
      (v) => Object.assign(v, { z: v[0][2] }),
      (d) => d[2],
    );
    // console.log("points:", points);
    // console.log("groups:", groups);
    // console.log("groups z:", groups);

    // console.log("yvals:", yVals);
    // console.log("numY:", numY);

    // console.log("xvals:", xVals);
    //console.log('numX:', numX)

    function yAxisticks() {
      if (d3.max(numY) === 2) {
        return 2;
      }
      if (d3.max(numY) === 1) {
        return 1;
      }
      if (d3.max(numY) <= 10) {
        return numY.length;
      } else {
        return 10;
      }
    }

    // remove previous graph if any
    d3.select("#" + container)
      .selectChildren()
      .remove();

    // Create the SVG container.
    const svg = d3
      .select("#" + container)
      .append("svg")
      .attr("width", width + marginLeft + marginRight)
      .attr("height", height + marginTop + marginBottom)
      .attr("preserveAspectRatio", "none")
      .append("g")
      //.attr("viewBox", [0, 0, width, height])
      //.attr("style", "max-width: 100%; height: auto; height: intrinsic;")
      .attr("transform", `translate(${marginLeft},${marginTop})`);

    // x-axis
    svg
      .append("g")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3
          .axisBottom(xScale)
          .ticks(xVals.length, d3.utcFormat("%Y"))
          .tickSize(15)
          .tickFormat(null),
      );

    //y-axis
    svg.append("g").attr("class", "y-axis").call(
      d3.axisLeft(yScale).ticks(yAxisticks(), "d"), //< --- need to fix this on low values (2 or below)
    );

    //const groups = d3.rollup(points, v => Object.assign(v, {z: v[0][2]}), d => d[2]);
    //type DataType ={label: any, val: any}
    // Declare the line generator.
    const line = d3
      .line<any>()
      .x((d) => xScale(d.label))
      .y((d) => yScale(d.val));

    // Append a path for the line.
    const path = svg
      .append("g")
      .append("path")
      .datum(props.data)
      //.data(groups.values()) // added to remove code errors lower down
      .attr("fill", "none")
      .attr("stroke", "#007a87")
      .attr("stroke-width", 1.5)
      .attr("class", "line")
      .attr("d", line);

    svg
      .append("g")
      .selectAll("circle")
      .data(props.data)
      .join("circle")
      .attr("cx", (d) => xScale(d.label))
      .attr("cy", (d) => yScale(d.val))
      .attr("r", 5)
      .attr("fill", "#007a87");

    svg
      .on("pointerenter", pointerentered)
      .on("pointermove", pointermoved)
      .on("pointerleave", pointerleft)
      .on("touchstart", (event) => event.preventDefault());

    // console.log("path:", path);
    // console.log("line:", line);

    const dot = svg.append("g").attr("display", "none");

    dot.append("circle").attr("r", 2.5);

    dot
      .append("text")
      .attr("text-anchor", "middle")
      .attr("class", "agentDots")
      .attr("fill", "#007a87")
      .attr("y", -10);

    const _bubbles: d3.CustomEventParameters = {
      bubbles: true,
      cancelable: false,
      detail: undefined,
    };

    function pointermoved(event: any) {
      const [xm, ym] = d3.pointer(event);
      const i = d3.leastIndex(points, ([x, y]) => Math.hypot(x - xm, y - ym));
      const [x, y, k] = points[i];
      // path
      //   .style("stroke", ({ z }) => (z === k ? null : "#ddd"))
      //   .filter(({ z }) => z === k)
      //   .raise();
      dot.attr("transform", `translate(${x},${y})`);
      dot.select("text").text(k);
      svg.property("value", props.data[i]).dispatch("value", _bubbles);
    }

    function pointerentered() {
      path.style("mix-blend-mode", null).style("stroke", "#ddd");
      dot.attr("display", null);
    }

    function pointerleft() {
      path.style("mix-blend-mode", "multiply").style("stroke", null);
      dot.attr("display", "none");
      svg.node().nodeValue = null;
      svg.dispatch("input", _bubbles);
    }
  };

  return (
    //<div>
    <div className={"LineGraph"} id={container} />
    //</div>
  );
}

export default LineChart2;
